import {
  CURRENT_OVERVIEW,
  loadDetails,
  PROJECT_FOREGIN_ID,
  propertyChange,
  REFRESH_DETAILS_PAGE
} from "../../../ducks/respondentsOverview";
import { SURVEY_RESULT_CHANGED } from "../../../ducks/surveyView";
import {
  extendLockEditingOfSurvey,
  hideReadOnlyDialog,
  hideRunner,
  LOCK_BY_USER,
  LOCK_FROM,
  LOCKED,
  lockEditingOfSurvey,
  PROJECT_NAME,
  READ_ONLY,
  READ_ONLY_BY_PERMISSIONS,
  saveSurveyResult,
  SHOW_READ_ONLY_DIALOG
} from "../../../ducks/surveyRunner";
import {
  resetSurvey,
  SURVEY_FUNDING_AREA,
  SURVEY_IDENTIFIER,
  SURVEY_NAME,
  SURVEY_PROGRAM,
  SURVEY_PROGRAM_INSTANCE,
  SURVEY_PROJECT,
  SURVEY_TEMPLATE
} from "../../../ducks/survey";

import { LINKS_KEY } from "../../../common/constant";
import SurveyRunner from "./SurveyRunner";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { showDialog } from "../../../ducks/confirmDialog";
import { JWT_EXPIRED_HEARTBEAT } from "../../../ducks/user";

const mapStateToProps = (state) => {
  return {
    identifier: state.survey[SURVEY_IDENTIFIER],
    surveyName: state.survey[SURVEY_NAME],
    surveyFundingArea: state.survey[SURVEY_FUNDING_AREA],
    surveyProgram: state.survey[SURVEY_PROGRAM],
    surveyProgramInstance: state.survey[SURVEY_PROGRAM_INSTANCE],
    surveyProject: state.survey[SURVEY_PROJECT],
    surveyTemplate: state.survey[SURVEY_TEMPLATE],
    links: state.survey[LINKS_KEY],
    projectName: state.surveyRunner[PROJECT_NAME],
    showReadOnlyDialog: state.surveyRunner[SHOW_READ_ONLY_DIALOG],
    refreshDetailsPage: state.respondentsOverview[REFRESH_DETAILS_PAGE],
    currentOverview: state.respondentsOverview[CURRENT_OVERVIEW],
    surveyResultChanged: state.surveyView[SURVEY_RESULT_CHANGED],
    lockByUser: state.surveyRunner[LOCK_BY_USER],
    lockFrom: state.surveyRunner[LOCK_FROM],
    locked: state.surveyRunner[LOCKED],
    readonly: state.surveyRunner[READ_ONLY],
    readOnlyByPermissions: state.surveyRunner[READ_ONLY_BY_PERMISSIONS],
    projectForeignId: state.respondentsOverview[PROJECT_FOREGIN_ID],
    jwtExpired: state.user[JWT_EXPIRED_HEARTBEAT]
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      saveSurveyResult,
      hideRunner,
      loadDetails,
      resetSurvey,
      propertyChange,
      showDialog,
      lockEditingOfSurvey,
      hideReadOnlyDialog,
      extendLockEditingOfSurvey
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(SurveyRunner);
